import React from 'react';
import PropTypes from 'prop-types';
import { Card, Tab, Row, Col, Nav, Button } from 'react-bootstrap';
import FalconCardBody from './FalconCardBody.js';
import classNames from 'classnames';
import { HashLink } from 'react-router-hash-link';
import Flex from './Flex.js';
import { useLocation } from 'react-router-dom';
import { camelize } from '../../helpers/utils.js';
import { useAppContext } from 'context/AppProvider.js';
import BtnExportToExcell from 'componentes/generic/ExportToExcel.js';

const FalconComponentCardHeader = ({
  light,
  className,
  title,
  children,
  AddAction,
  exportData
}) => {
  const location = useLocation();
  const {
    config: { isRTL }
  } = useAppContext();
  return (
    <Card.Header
      className={classNames({ 'bg-body-tertiary': light }, className)}
    >
      <Row
        className={classNames('g-2', {
          'align-items-center': !children,
          'align-items-end ': children
        })}
      >
        <Col>
          {title && (
            <Flex>
              <h5
                className="mb-0 hover-actions-trigger text-truncate text-nowrap"
                id={camelize(title)}
              >
                {isRTL ? (
                  <>
                    <HashLink
                      to={`${location.pathname}#${camelize(title)}`}
                      className="hover-actions ps-2"
                      style={{ top: 0, left: '-25px' }}
                    >
                      #
                    </HashLink>
                    {title}
                  </>
                ) : (
                  <>
                    {title}
                    <HashLink
                      to={`${location.pathname}#${camelize(title)}`}
                      className="hover-actions ps-2"
                      style={{ top: 0, right: '-25px' }}
                    >
                      #
                    </HashLink>
                  </>
                )}
              </h5>
            </Flex>
          )}
          {children}
        </Col>
        {AddAction && (
          <Col
            className={classNames({
              'col-auto': !children,
              'col-md-auto col-12': children
            })}
          >
            <Row className="d-inline-block">
              <Col>
                <Nav variant="pills" className="nav-pills-falcon m-0">
                  <Nav.Item>
                    <Nav.Link as={Button} size="sm" onClick={AddAction}>
                      + Agregar
                    </Nav.Link>
                  </Nav.Item>
                  {/* <Nav.Item>
                    <Nav.Link as={Button} size="sm" eventKey="code">
                      Code
                    </Nav.Link>
                  </Nav.Item> */}
                  {/* <Button variant="" type="button" size="sm">
            Preview
          </Button>
          <Button variant="" type="button" size="sm">
            Code
          </Button> */}
                </Nav>
              </Col>
            </Row>
          </Col>
        )}
        {exportData && (
          <Col
            className={classNames({
              'col-auto': !children,
              'col-md-auto col-12': children
            })}
          >
            <Row className="d-inline-block">
              <Col>
                <BtnExportToExcell
                  dataReport={exportData}
                  fileName="Reporte por Periodo"
                />
              </Col>
            </Row>
          </Col>
        )}
      </Row>
    </Card.Header>
  );
};

const FalconComponentCard = ({
  children,
  multiSections,
  noGuttersBottom,
  ...rest
}) => {
  return (
    <Card className={classNames({ 'mb-3': !noGuttersBottom })} {...rest}>
      {multiSections ? (
        <>{children}</>
      ) : (
        <Tab.Container defaultActiveKey="preview">{children}</Tab.Container>
      )}
    </Card>
  );
};

FalconComponentCard.Header = FalconComponentCardHeader;
FalconComponentCard.Body = FalconCardBody;

FalconComponentCard.propTypes = {
  children: PropTypes.node,
  multiSections: PropTypes.bool,
  noGuttersBottom: PropTypes.bool
};

FalconComponentCardHeader.propTypes = {
  light: PropTypes.bool,
  className: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node,
  AddAction: PropTypes.func,
  exportData: PropTypes.func
};

export default FalconComponentCard;
